export const AVATAR_SIZE = 28;
export const EMPTY_ICON_SIZE = 16;
export const INITIALS_FONT_SIZE = '12px';
